import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// Make Pusher available globally for Laravel Echo
window.Pusher = Pusher;

// Get base URL from backend config
import backend from '../router/backend';

// Get auth token from store
import store from '../store';

// Create Echo instance
let echoInstance = null;

export const initializeEcho = () => {
  // Don't initialize if already initialized
  if (echoInstance) {
    return echoInstance;
  }

  const authToken = store.state.auth?.authToken;
  
  if (!authToken) {
    console.warn('Echo: No auth token available, skipping Echo initialization');
    return null;
  }

  // Get Reverb configuration from environment
  // These should match the values in backend config/reverb.php
  const reverbHost = process.env.VUE_APP_REVERB_HOST;
  const reverbPort = process.env.VUE_APP_REVERB_PORT || '443';
  const reverbScheme = process.env.VUE_APP_REVERB_SCHEME || 'https';
  const reverbKey = process.env.VUE_APP_REVERB_APP_KEY;

  if (!reverbHost || !reverbKey) {
    console.warn('Echo: REVERB_HOST or REVERB_APP_KEY not configured, skipping Echo initialization');
    return null;
  }

  // Broadcasting auth endpoint - Broadcast::routes() creates /broadcasting/auth at root level
  // Remove /api/ from baseURL since broadcasting routes are not under /api/
  let authEndpoint;

  // Get HOST from backend config (same as backend.js uses)
  const HOST = process.env.VUE_APP_BACKEND_HOST;

  if (!HOST) {
    console.error(
      "Echo: VUE_APP_BACKEND_HOST is not defined, cannot create auth endpoint"
    );
    return null;
  }

  // Remove trailing slash from HOST and construct auth endpoint
  const cleanHost = HOST.replace(/\/$/, "");
  authEndpoint = `${cleanHost}/broadcasting/auth`;

  // Validate URL
  try {
    new URL(authEndpoint);
  } catch (e) {
    console.error("Echo: Invalid auth endpoint URL:", authEndpoint, e);
    return null;
  }

  echoInstance = new Echo({
    broadcaster: "pusher",
    key: reverbKey,
    wsHost: reverbHost,
    wsPort: reverbPort,
    wssPort: reverbPort,
    forceTLS: reverbScheme === "https",
    enabledTransports: ["ws", "wss"],
    // Reverb doesn't use cluster, but pusher-js 8.0+ requires it
    // Set to null or empty string to avoid the error
    cluster: "",
    authEndpoint: authEndpoint,
    auth: {
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: "application/json",
      },
    },
  });

  console.log('Echo initialized with auth endpoint:', authEndpoint);

  return echoInstance;
};

export const getEcho = () => {
  if (!echoInstance) {
    return initializeEcho();
  }
  return echoInstance;
};

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};

export default {
  initializeEcho,
  getEcho,
  disconnectEcho,
};

